module.exports = __webpack_public_path__ + "img/default.4a39ca58.png";